import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import './AuthPages.css';

const WHATSAPP_NUMBER = '919842724724';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('login'); // login | forgot
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  // forgot password
  const [fpPhone, setFpPhone] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    if (phone.length !== 10) return toast.error('Enter valid 10-digit phone number');
    setLoading(true);
    try {
      const data = await login(phone, password);
      if (data.success) {
        toast.success('Welcome back! 🙏');
        if (data.user.role === 'admin') return navigate('/admin');
        if (data.user.status === 'approved') return navigate('/dashboard');
        navigate('/pending');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    }
    setLoading(false);
  };

  const handleForgotWhatsApp = () => {
    if (fpPhone.length !== 10) return toast.error('Enter your registered 10-digit phone number first');
    const message = `Hi, I forgot my password for Suvaran Maran Matrimony.%0ARegistered Phone: ${fpPhone}%0APlease help me reset my password.`;
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
    toast.success('WhatsApp opened! Send the message to reset your password 📲');
  };

  return (
    <div className="auth-page">
      <div className="auth-left">
        <div className="auth-left-content">
          <div className="auth-logo">🪷</div>
          <h2>Suvaran Maran Matrimony</h2>
          <p className="auth-tagline">உங்கள் வாழ்க்கை துணையை கண்டறியுங்கள்</p>
          <div className="auth-features">
            <div className="af-item">🛡️ Horoscope Type Protection</div>
            <div className="af-item">⭐ 27 Nakshatra Matching</div>
            <div className="af-item">✅ Admin Verified Profiles</div>
            <div className="af-item">🔒 Contact Privacy System</div>
          </div>
        </div>
      </div>

      <div className="auth-right">
        <div className="auth-card">
          {tab === 'login' ? (
            <>
              <h2>Welcome Back</h2>
              <p className="auth-sub">Login with your registered phone number</p>
              <form onSubmit={handleLogin}>
                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <label className="form-label-tamil">கைபேசி எண்</label>
                  <input className="form-input" type="tel" value={phone}
                    onChange={e => setPhone(e.target.value.replace(/\D/,'').slice(0,10))}
                    placeholder="Enter 10-digit phone number" required />
                </div>
                <div className="form-group">
                  <label className="form-label">Password</label>
                  <label className="form-label-tamil">கடவுச்சொல்</label>
                  <div className="input-with-icon">
                    <input className="form-input" type={showPwd ? 'text' : 'password'}
                      value={password} onChange={e => setPassword(e.target.value)}
                      placeholder="Enter your password" required />
                    <button type="button" className="show-pwd" onClick={() => setShowPwd(!showPwd)}>
                      {showPwd ? '🙈' : '👁️'}
                    </button>
                  </div>
                </div>
                <div className="forgot-link">
                  <button type="button" className="link-btn" onClick={() => setTab('forgot')}>
                    Forgot Password?
                  </button>
                </div>
                <button type="submit" className="btn btn-gold" style={{width:'100%'}} disabled={loading}>
                  {loading ? <><span className="spinner" style={{width:18,height:18}} /> Logging in...</> : '🔐 Login'}
                </button>
              </form>
              <div className="auth-footer">
                Don't have an account? <Link to="/register">Register Free →</Link>
              </div>
            </>
          ) : (
            <>
              <h2>Forgot Password?</h2>
              <p className="auth-sub">Contact us on WhatsApp to reset your password</p>

              <div className="form-group">
                <label className="form-label">Your Registered Phone Number</label>
                <label className="form-label-tamil">பதிவு செய்த கைபேசி எண்</label>
                <input
                  className="form-input"
                  type="tel"
                  value={fpPhone}
                  onChange={e => setFpPhone(e.target.value.replace(/\D/,'').slice(0,10))}
                  placeholder="Enter your 10-digit phone number"
                />
              </div>

              {/* WhatsApp Reset Button */}
              <button
                className="btn btn-gold"
                style={{ width: '100%', marginBottom: '12px' }}
                onClick={handleForgotWhatsApp}
              >
                📲 Contact Admin on WhatsApp
              </button>

              {/* Info Box */}
              <div style={{
                background: '#f0fdf4',
                border: '1px solid #86efac',
                borderRadius: '10px',
                padding: '14px',
                marginBottom: '16px',
                fontSize: '13px',
                color: '#166534',
                lineHeight: '1.6'
              }}>
                <strong>📋 How it works:</strong><br />
                1. Enter your registered phone number above<br />
                2. Click the WhatsApp button<br />
                3. Send the pre-filled message to admin<br />
                4. Admin will reset your password shortly<br />
                5. Login with your new password ✅
              </div>

              <div className="auth-footer">
                <button className="link-btn" onClick={() => { setTab('login'); setFpPhone(''); }}>
                  ← Back to Login
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
